export enum TeamStatus {
    Assigned = 0,
    Unassigned = 1,
    NeedsReview = 2
}

export enum TeamInfoMode {
    Refresh = 0,
    Assignment = 1,
    Release = 2
}

export enum TeamEntryType {
    Recruiter = 0,
    Leader = 1,
    PerDiemRecruiter = 2,
    CredentialingSpecialist = 3,
    PayrollWor = 4,
    PayrollPre = 5,
    TravelXSpecialist = 6,
    TravelXEscalation = 7,
    PermanentRecruiter = 8,
    AccessControlRecruiter = 9,
    CandidatePayrollRep = 10,
    WfdRecruiter = 11
}

export enum CustomHeaderType {
    Default = 0,
    WorkforceDisruptionPlacementsCandidate = 1
}
